import type { ColumnDef } from '@vnetwork/ui/data';
import { RowMenu } from '../../components/RowMenu';
import { Mono, LinkButton } from '../s3-parts';
import { formatIamDate } from './iam-format';

export interface IamEntityColumnsConfig<T> {
  /** Human name shown in the first column (user/group/role name). */
  nameOf: (row: T) => string;
  /** RFC3339 create timestamp, if the entity exposes one. */
  dateOf: (row: T) => string | null | undefined;
  onView: (row: T) => void;
  onDelete: (row: T) => void;
}

/**
 * Shared column set for the three IAM list tables (users, groups, roles). They
 * differ only in the name field, so a single factory keeps the name/created/
 * kebab layout identical across all of them.
 */
export function iamEntityColumns<T>(cfg: IamEntityColumnsConfig<T>): ColumnDef<T, unknown>[] {
  return [
    {
      id: 'name',
      header: 'Name',
      cell: ({ row }) => (
        <LinkButton onClick={() => cfg.onView(row.original)}>
          <Mono>{cfg.nameOf(row.original)}</Mono>
        </LinkButton>
      ),
    },
    {
      id: 'create_date',
      header: 'Created',
      size: 220,
      cell: ({ row }) => <Mono>{formatIamDate(cfg.dateOf(row.original))}</Mono>,
    },
    {
      id: 'actions',
      header: '',
      size: 64,
      cell: ({ row }) => (
        <RowMenu
          items={[
            { label: 'View', onSelect: () => cfg.onView(row.original) },
            { label: 'Delete', onSelect: () => cfg.onDelete(row.original), danger: true },
          ]}
        />
      ),
    },
  ];
}
